import MarketSignalScrollerEntry from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller-entry';
import dayjs from 'dayjs';
import MarketSignalScrollerPanel from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller-panel';
import articleListStyles from '@/shared/components/flash-highlight.module.scss';

export default function MarketSignalSingleScroller({ selectedStream }: { selectedStream: string }) {
  const flash = (index: number, date: string) => {
    if (/*index === 0 && */ dayjs(date).isAfter(dayjs().subtract(5, 'minute')))
      return articleListStyles.flashArticle;

    return '';
  };

  return (
    <MarketSignalScrollerPanel
      paused={false}
      renderSignal={(value, index) => (
        <div
          key={value._id + '-' + index}
          className={`small  border-top-0  pb-3 ${flash(index, value.dateCreated)}`}
        >
          <MarketSignalScrollerEntry signal={value} topics={[]} interactive={true} />
        </div>
      )}
      onMissedUpdate={() => {}}
      selectedStream={selectedStream}
    />
  );
}
